import data from "@/features/geo/data/postal-codes.json";

export type PostalCode = {
  code: string;
  city: string;
  // The municipality holding most of the postal code's addresses. A postal
  // district is not contained in one municipality — 245 of the 1,089 codes span
  // several (9440 Aabybro covers parts of Jammerbugt, Brønderslev and Aalborg) —
  // so this is the one to show, and `municipalities` the ones to match on.
  // See decisions/leads.md.
  municipality: string;
  // Every municipality the postal code has an address in, Danish-sorted.
  municipalities: readonly string[];
};

// Derived from DAR house numbers on Datafordeleren and baked in; postal codes
// change a few times a year. Re-generate with `bun scripts/fetch-postal-codes.ts`.
export const POSTAL_CODES: readonly PostalCode[] = data as PostalCode[];

const BY_CODE = new Map(POSTAL_CODES.map((p) => [p.code, p] as const));

export function findPostalCode(code: string): PostalCode | null {
  return BY_CODE.get(code) ?? null;
}

export function isValidPostalCode(code: string): boolean {
  return BY_CODE.has(code);
}
